const Instagram = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7501 4.5C16.7439 4.5 17.6861 4.89375 18.3986 5.60156C19.1111 6.30938 19.5001 7.25625 19.5001 8.25V15.75C19.5001 16.7437 19.1064 17.6859 18.3986 18.3984C17.6907 19.1109 16.7439 19.5 15.7501 19.5H8.25012C7.25637 19.5 6.31418 19.1063 5.60168 18.3984C4.88918 17.6906 4.50012 16.7437 4.50012 15.75V8.25C4.50012 7.25625 4.89387 6.31406 5.60168 5.60156C6.3095 4.88906 7.25637 4.5 8.25012 4.5H15.7501ZM15.7501 3H8.25012C5.36262 3 3.00012 5.3625 3.00012 8.25V15.75C3.00012 18.6375 5.36262 21 8.25012 21H15.7501C18.6376 21 21.0001 18.6375 21.0001 15.75V8.25C21.0001 5.3625 18.6376 3 15.7501 3Z"
      fill="white"
    />
    <path
      d="M16.8751 8.25C16.2517 8.25 15.7501 7.74844 15.7501 7.125C15.7501 6.50156 16.2517 6 16.8751 6C17.4939 6 18.0001 6.50156 18.0001 7.125C18.0001 7.74844 17.4939 8.25 16.8751 8.25ZM12.0001 9C13.6548 9 15.0001 10.3453 15.0001 12C15.0001 13.6547 13.6548 15 12.0001 15C10.3454 15 9.00012 13.6547 9.00012 12C9.00012 10.3453 10.3454 9 12.0001 9ZM12.0001 7.5C9.51575 7.5 7.50012 9.51562 7.50012 12C7.50012 14.4844 9.51575 16.5 12.0001 16.5C14.4845 16.5 16.5001 14.4844 16.5001 12C16.5001 9.51562 14.4845 7.5 12.0001 7.5Z"
      fill="white"
    />
  </svg>
);

export default Instagram;
